import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.object.assign";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import { mapMutations, mapState } from 'vuex';
import get from 'lodash/get';
import listMixin from '../assetMgmt/listMixin';
import { userItemsPerListMixin } from '@/utils/vuex';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewISFMAccessMgmt',
  mixins: [listMixin, userItemsPerListMixin],
  data: function data() {
    return {
      selected: [],
      tableOptions: _objectSpread({}, defaultTableOptions),
      fab: false,
      search: null,
      dialog: false,
      tableLoading: false,
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      buttons: [{
        title: this.$i18n_t('Common.create'),
        icon: 'fal fa-plus',
        action: 'addItem',
        valid: !this.disabled
      }],
      items: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: '',
          value: 'icon'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.id'),
          value: 'id'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.firstName'),
          value: 'user.firstName'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.lastName'),
          value: 'user.lastName'
        }, {
          sortable: true,
          text: this.$i18n_t('Common.email'),
          value: 'user.email'
        }, {
          sortable: true,
          text: this.$i18n_t('IS.FM.AccessMgmt.building'),
          value: 'dtwinData.title'
        }, {
          sortable: true,
          text: this.$i18n_t('IS.FM.AccessMgmt.accObjct'),
          value: 'accessObjectData.title'
        }, {
          sortable: false,
          text: this.$i18n_t('IS.FM.AccessMgmt.Restrictions'),
          value: 's'
        }, {
          sortable: false,
          text: '',
          value: '',
          align: 'right'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  }),
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  created: function created() {
    this.tableOptions.page = defaultTableOptions.page;
    this.tableOptions.itemsPerPage = this.savedUserItemsPerList();
  },
  mounted: function mounted() {
    this.$store.state.app.loading = false;
    this.fetchIsFmAccessMgmt();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    keyRigthsIcon: function keyRigthsIcon(keys) {
      var _this = this;

      keys.forEach(function (key) {
        var icons = [];

        if (key.data.dateFrom || key.data.dateTo) {
          icons.push({
            icon: 'fal fa-calendar-alt',
            tooltip: _this.$i18n_t('IS.FM.AccessMgmt.date')
          });
        }

        if (key.data.days.length) {
          icons.push({
            icon: 'fal fa-calendar-day',
            tooltip: _this.$i18n_t('IS.FM.AccessMgmt.weekDays')
          });
        }

        if (key.data.timeFrom || key.data.timeTo) {
          icons.push({
            icon: 'fal fa-watch',
            tooltip: _this.$i18n_t('IS.FM.AccessMgmt.timeWindow')
          });
        }

        if (key.data.usagePerWeek && key.data.usagePerWeek !== '0') {
          icons.push({
            icon: 'fal fa-calendar-week',
            tooltip: _this.$i18n_t('IS.FM.AccessMgmt.usagePerWeek')
          });
        }

        key.icons = icons;
      });
    },
    keyTwinTitle: function keyTwinTitle(item) {
      return "".concat(get(item, 'dtwinData.title'), " (").concat(get(item, 'parentData.title'), ")");
    },
    editItem: function editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    addItem: function addItem() {
      this.dialog = true;
    },
    fetchIsFmAccessMgmt: function fetchIsFmAccessMgmt() {
      var _this2 = this;

      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      this.tableLoading = true;
      ApiService.isFmAccessFetch(this).then(function (data) {
        _this2.items = data;

        _this2.keyRigthsIcon(_this2.items);
      }).catch(function (error) {
        if (error.response && _this2.$i18n_t("Error.".concat(error.response.data.message))) {
          _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this2.$snack(_this2.$i18n_t('Common.errorLoadingData'), 'error');
        }
      }).finally(function () {
        _this2.$store.state.app.loading = false;
        _this2.tableLoading = false;
      });
    },
    deleteItem: function deleteItem(item) {
      confirm(this.$i18n_t('Common.areYouSure')) && this.deleteToDB(item);
    },
    close: function close() {
      var _this3 = this;

      this.dialog = false;
      setTimeout(function () {
        _this3.editedItem = Object.assign({}, _this3.defaultItem);
        _this3.editedIndex = -1;
      }, 300);
    },
    save: function save(data) {
      if (this.editedIndex > -1) {
        this.updateToDB(data);
      } else {
        this.saveToDB(data);
      }

      this.close();
    },
    saveToDB: function saveToDB(item) {
      var _this4 = this;

      this.tableLoading = true;
      ApiService.isFmAccessCreate(item).then(function () {
        _this4.$snack(_this4.$i18n_t('IS.FM.AccessMgmt.accessObjectSaved'), 'success');
      }).catch(function (error) {
        if (error.response && _this4.$i18n_t("Error.".concat(error.response.data.message))) {
          _this4.$snack(_this4.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this4.$snack(_this4.$i18n_t('IS.FM.AccessMgmt.errorObjectSave'), 'error');
        }
      }).finally(function () {
        _this4.fetchIsFmAccessMgmt();
      });
    },
    updateToDB: function updateToDB(item) {
      var _this5 = this;

      this.tableLoading = true;
      ApiService.isFmAccessUpdate(item).then(function () {
        _this5.$snack(_this5.$i18n_t('IS.FM.AccessMgmt.accessObjectSaved'), 'success');
      }).catch(function (error) {
        if (error.response && _this5.$i18n_t("Error.".concat(error.response.data.message))) {
          _this5.$snack(_this5.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this5.$snack(_this5.$i18n_t('IS.FM.AccessMgmt.errorObjectSave'), 'error');
        }
      }).finally(function () {
        _this5.fetchIsFmAccessMgmt();
      });
    },
    deleteToDB: function deleteToDB(item) {
      var _this6 = this;

      this.tableLoading = true;
      ApiService.isFmAccessDelete(item.id).then(function () {
        _this6.$snack(_this6.$i18n_t('IS.FM.AccessMgmt.accessObjectDel'), 'success');
      }).catch(function (error) {
        if (error.response && _this6.$i18n_t("Error.".concat(error.response.data.message))) {
          _this6.$snack(_this6.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this6.$snack(_this6.$i18n_t('IS.FM.AccessMgmt.errorObjectDel'), 'error');
        }
      }).finally(function () {
        _this6.fetchIsFmAccessMgmt();
      });
    }
  })
};